const serviceUrlEcoOrganisme = `${__configuration.apiUrl}/massia/registre-eco-organismes`;
const serviceUrlEcominero = `${__configuration.apiUrl}/massia/registre-declaration-ecominero`;
const serviceUrldeclarationRndts = `${__configuration.apiUrl}/massia/gestion/declaration-rndts`;

export default class RegistresLegacyService {
	constructor($http) {
		this.$http = $http;
		this.apiResult = null;
	}

	async getClients() {
		const siteUrl = `${__configuration.apiUrl}/massia/sites-clients/headers`;
		const res = await this.$http.get(siteUrl);
		return res.data;
	}

	async getSocietes() {
		const url = `${__configuration.apiUrl}/massia/societes-commerciales/header`;
		const res = await this.$http.get(url);
		return res.data;
	}

	async getSitesBySocieteId(idSociete) {
		const url = `${__configuration.apiUrl}/massia/sites-commerciaux/header/${idSociete}`;
		const res = await this.$http.get(url);
		return res.data;
	}

	async getAllEcoOrganismes() {
		const res = await this.$http.get(`${__configuration.apiUrl}/massia/eco-organisme-inertes`);
		if (res.data.length > 0) {
			return res.data
				.map((eo) => ({
					id: eo.societe.id,
					libelle: eo.societe.libelle,
					code: eo.societe.code
				})) // on distinct sur l'id
				.filter((eo, index, array) => array.findIndex((item) => item.id === eo.id) === index);
		}
	}

	async getGridConfig() {
		const res = await this.$http.get(`${serviceUrlEcoOrganisme}/grid-config`);
		return res.data;
	}

	async getRegistreEcoOrganismes(form) {
		const url = `${serviceUrlEcoOrganisme}`;

		const res = await this.$http.post(url, form);
		return res;
	}

	async exportRegistreEcoOrganismes(form) {
		const url = `${serviceUrlEcoOrganisme}/export`;

		const res = await this.$http.post(url, form, {
			responseType: 'arraybuffer'
		});
		return res;
	}

	async exportRegistreDeclarationEcominero(form) {
		const url = `${serviceUrlEcominero}/export`;

		const res = await this.$http.post(url, form, {
			responseType: 'arraybuffer'
		});
		return res;
	}

	async getDeclarationRndts(filters, sorts, pagination, idSociete, idSiteCom, dateDebut, dateFin, typeEntreeSortie, typeRegistre) {
		const res = await this.$http.get(serviceUrldeclarationRndts, {
			params: {
				filters: JSON.stringify(filters || []),
				sorts: JSON.stringify(sorts || []),
				pagination: JSON.stringify(pagination || { skip: 0, take: 0 }),
				idSociete: JSON.stringify(idSociete || 0),
				idSiteCom: JSON.stringify(idSiteCom || 0),
				dateDebut: JSON.stringify(dateDebut || null),
				dateFin: JSON.stringify(dateFin || null),
				typeEntreeSortie: JSON.stringify(typeEntreeSortie),
				typeRegistre: JSON.stringify(typeRegistre)
			}
		});

		return res.data;
	}

	async printDeclarationRndts(idSociete, idSite, debut, fin, typeEntreeSortie, typeRegistre, fileName) {
		const filtres = {
			idSociete: idSociete || 0,
			idSite: idSite || 0,
			debut: debut,
			fin: fin,
			typeEntreeSortie: typeEntreeSortie,
			typeRegistre: typeRegistre,
			fileName: fileName
		};
		const url = `${serviceUrldeclarationRndts}/print`;
		const res = await this.$http.get(url, {
			params: {
				filtres: JSON.stringify(filtres || {})
			},
			responseType: 'arraybuffer'
		});

		return res;
	}

	async postApi(idSociete, idSiteCom, dateDebut, dateFin, typeEntreeSortie, typeRegistre) {
		//TODO: Call MASSIA API => Liste des ID des déclaration à transmettre ?
		const url = `${__configuration.apiUrl}/massia/gestion/declaration-rndts/teletransmettre`;
		const res = await this.$http.get(url, {
			params: {
				idSociete: JSON.stringify(idSociete),
				idSiteCom: JSON.stringify(idSiteCom | 0),
				dateDebut: JSON.stringify(dateDebut),
				dateFin: JSON.stringify(dateFin),
				typeEntreeSortie: JSON.stringify(typeEntreeSortie),
				typeRegistre: JSON.stringify(typeRegistre)
			}
		});

		return res.data || res;
	}

	setApiResult(res) {
		this.apiResult = res;
	}

	getApiResult() {
		return this.apiResult;
	}
}
RegistresLegacyService.$inject = ['$http'];
